import { getUTCNow, lastDayOfYearUTC } from '@epicuro-next/utilities';
import {
  createInstanceWithChildren,
  getProvider,
} from '../../../../utils/dynamic-items-utils';
import { getRecommendationsDataProviderItem } from '../../../recommendations-provider';
import { productsOnTheWayApiResponseTransform } from '../../../tenants/common/products-on-the-way/products-on-the-way-helpers';
import { SingleProductDataType } from '../../../types/single-product-data-type';
import { GroupedProductsContainer } from './grouped-products-container';
import { createApiRequestPayloadPropertiesProvider } from './helpers/create-api-request-payload-properties-provider';
import { groupProductDataByMonth } from './helpers/group-product-data-by-delivery-month';
import { PocketsFilters } from './pockets-filters';
import { POCKETS_LOOK_AHEAD_PROVIDER_PROPERTIES } from './pockets-look-ahead-provider-properties';

//  public maxDate = DateTime.utc().toJSDate();

// ngbDateToUTC(targetNgbDate)

// const isoDate = DateTime.utc(
//   ngbDate.year,
//   ngbDate.month,
//   ngbDate.day,
// ).toISO();

// const computedUtc = isEndDate
//   ? getUtcDayTime(isoDate, true)
//   : getUtcDayTime(isoDate);

//utcDateTime

//  ? formatDateToLocaleDateUtc(value, locale, this.dateFormat)
// : formatDateToLocaleDate(value, locale, this.dateFormat);

const dateRangeStartWith = (function () {
  const today = getUTCNow();
  const endOfTheYear = lastDayOfYearUTC().toJSDate().toISOString();
  return {
    from: today,
    to: endOfTheYear,
  };
})();

const apiRequestPayloadPropertiesProvider =
  createApiRequestPayloadPropertiesProvider({
    fromDate: {
      provider: 'id:root',
      property: 'fromDate',
    },
    toDate: {
      provider: 'id:root',
      property: 'toDate',
    },
    shipTo: {
      provider: 'id:root',
      property: 'shipTo',
    },
    filterMissingImages: {
      provider: 'id:root',
      property: 'filterMissingImages',
    },
    brandId: {
      provider: 'id:root',
      property: 'brandId',
    },
  });

const recommendationsData = getRecommendationsDataProviderItem({
  panelName: {
    provider: 'id:root',
    property: 'panelName',
  },
  apiRequestPayloadPropertiesProvider,
});

export const pocketsLookAheadContainer = createInstanceWithChildren({
  id: 'root',
  contentTypeId: 'dynamic-collections-renderer',
  data: {
    ...POCKETS_LOOK_AHEAD_PROVIDER_PROPERTIES,
    productData: {
      ...getProvider(recommendationsData, 'result'),
      transform: productsOnTheWayApiResponseTransform().toString(),
    },
    groupedProductData: {
      provider: 'id:root',
      property: 'productData',
      transform: groupProductDataByMonth().toString(),
    },
    nrOfProductsToShow: 999,
    panelName: 'ProductsOnTheWayTestPanel',
    isLoading: {},
    hasError: {},
    hasData: {},
    panelTrackingId: '',
    hasItems: {
      provider: 'self',
      property: 'productData',
      transform: function (productData: SingleProductDataType[]): boolean {
        return productData !== undefined && productData.length > 0;
      }.toString(),
    },
    fontSize: '1.2rem',
    filterMissingImages: true,
    quantityFontSize: '2rem',
    showOrdinalSuffix: true,
    singleItemStyle:
      'background: #fff; box-shadow: 0 7px 30px -10px rgba(var(--p-card-shadow, var(--color-brand-gray-700-rgb, 153, 153, 153)), 50%)',
    singleItemClass: ['d-block', 'mb-1', 'col-2'],
    overrideProductTitleFromPropertyKey: 'masterProductTitle',
    dateRange: {
      provider: 'id:date-range-filter',
      property: 'selectionChanged',
    },
    dateRangeStartWith: dateRangeStartWith,
    fromDate: {
      provider: 'self',
      property: 'dateRange',
      transform: function (dateRange: string) {
        const [fromDate, _] = dateRange.split('-');
        return new Date(fromDate.trim()).toISOString();
      }.toString(),
    },
    toDate: {
      provider: 'self',
      property: 'dateRange',
      transform: function (dateRange: string) {
        const [_, toDate] = dateRange.split('-');
        return new Date(toDate.trim()).toISOString();
      }.toString(),
    },
    shipTo: {
      provider: 'id:stores-filter-select',
      property: 'toggleFilter',
      startWith: [],
    },
    selectedCategory: {
      provider: 'id:category-filter-select',
      property: 'toggleFilter',
      startWith: [],
    },
    accountId: {
      provider: 'GlobalStoreProviderService',
      property: {
        path: 'accounts.activeAccount.accountId',
      },
    },
    filterSelectVariables: [],
  },
  children: [recommendationsData, PocketsFilters, GroupedProductsContainer],
});
